<ng-container [ngSwitch]="type">
  <ng-container *ngSwitchCase="1">
    <mat-form-field appearance="outline" (click)="onClick()" [style]="style">
      <mat-label>{{ label | translate }}</mat-label>
      <mat-select
        [formControl]="ctrl"
        (selectionChange)="onUserChangeSelection($event)"
      >
        <mat-option>
          <ngx-mat-select-search
            [formControl]="filterCtrl"
            [placeholderLabel]="'search' | translate"
            [noEntriesFoundLabel]="'no-coincidences' | translate"
          >
          </ngx-mat-select-search>
        </mat-option>
        <mat-option
          [value]="option.value"
          *ngFor="let option of filteredOptions | async"
          >{{ option.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </ng-container>
  <ng-container *ngSwitchCase="2">
    <mat-select
      [formControl]="ctrl"
      (click)="onClick()"
      class="form-control"
      [style]="style"
      (selectionChange)="onUserChangeSelection($event)"
    >
      <mat-option>
        <ngx-mat-select-search
          [formControl]="filterCtrl"
          [placeholderLabel]="'search' | translate"
          [noEntriesFoundLabel]="'no-coincidences' | translate"
        >
        </ngx-mat-select-search>
      </mat-option>
      <mat-option
        [value]="option.value"
        *ngFor="let option of filteredOptions | async"
        >{{ option.label }}
      </mat-option>
    </mat-select>
  </ng-container>
</ng-container>
